import { createTheme } from '@material-ui/core/styles';

export default createTheme({
  typography: {
    fontFamily: [
      'Averta',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    button: {
      textTransform: 'none',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1440,
      xl: 1920,
    },
  },

  palette: {
    type: 'light',
  },
  overrides: {
    // targeting refresh button
    RaAppBar: {
      toolbar: {
        '& button': {
          '&:nth-child(7)': {
            display: 'none',
          },
        },
      },
    },
    // Style sheet name ⚛️
    MuiButton: {
      // Name of the rule
    },
    RaLayout: {
      appFrame: {
        marginTop: '70px !important',
        // maxHeight: '93.3vh',
      },
      root: {
        backgroundColor: 'transparent',
      },
      content: {
        padding: '0 !important',
        backgroundColor: 'transparent',
      },
      contentWithSidebar: {
        overflow: 'auto',
        height: 'calc(100vh - 64px)',
        '&::-webkit-scrollbar': {
          width: '16px',
          padding: '0 5px',
        },

        '&::-webkit-scrollbar-track': {
          background: '#fefefe',
          margin: '0 5px',
        },

        '&::-webkit-scrollbar-thumb': {
          background: '#CACFD8',
          borderRadius: '100px',
          border: '4px solid transparent',
          backgroundClip: 'padding-box',
        },

        '&::-webkit-scrollbar-thumb:hover': {
          background: '#99A0AE',
          borderRadius: '100px',
          border: '4px solid transparent',
          backgroundClip: 'padding-box',
        },
      },
    },
  },
});
